<template>
    <div>
        <Request
                ref="requestPublish"
                root="/event-calendar-panel/publish"
                method="PUT"
                :onRequestSuccess="updateEvents"
                :onRequestError="requestError">
            <slot slot="body">
                <Request
                        ref="requestDates"
                        root="/event-calendar-panel/dates"
                        :onRequestSuccess="updateEvents"
                        :onRequestError="requestError">
                    <slot slot="body">
                        <b-card :class="dataEventCalendarStatus.cardClass">
                            <b-row class="mb-4">
                                <b-col lg="3" md="4" sm="12">
                                    <b-badge style="position: absolute; z-index: 1015" v-if="dataEventCalendarStatus.caption !== ''" class="p-2" :variant="dataEventCalendarStatus.badgeVariant">{{dataEventCalendarStatus.caption}}</b-badge>
                                </b-col>
                                <b-col :class="{'text-right':!Core.Display.isMobile() }" lg="9" md="7" sm="12">

                                    <slot name="beforeActions">
                                    </slot>

                                    <b-button-group class="p-1">
                                        <b-button v-if="Core.Session.AuthUser.can('event_calendar_management_post')" @click="onAddEvent" class="btn btn-light mr-2">{{Core.Definition.getDefinition('Nouvel événement')}}</b-button>
                                    </b-button-group>

                                    <b-button-group v-if="Core.Session.AuthUser.can('event_calendar_management_put_publish')" class="p-1">
                                        <b-button @click="$refs.modalEventTemplateSelector.open = true" class="btn btn-light">{{Core.Definition.getDefinition('Charger un modèle')}}</b-button>
                                        <b-dropdown variant="light" class="mr-2" size="sm" right no-caret>
                                            <template slot="button-content">
                                                <i class="fa fa-angle-down"></i>
                                            </template>
                                            <b-dropdown-item @click="$refs.modalConfirmSaveTemplate.open = true" href="#">{{Core.Definition.getDefinition('Enregistrer comme modèle')}}</b-dropdown-item>
                                            <b-dropdown-item @click="$refs.modalConfirmCreateTemplate.open = true" href="#">{{Core.Definition.getDefinition('Créer un modèle')}}</b-dropdown-item>
                                            <b-dropdown-item @click="$router.push(Core.Definition.getDefinition('/evenement/calendrier/modeles'))" href="#">{{Core.Definition.getDefinition('Liste des modèles')}}</b-dropdown-item>
                                        </b-dropdown>
                                    </b-button-group>

                                    <b-button-group v-if="Core.Session.AuthUser.can('event_calendar_management_put_publish')" class="p-1">
                                        <b-button @click="$refs.modalConfirmPublishWeek.open = true" class="btn btn-success">{{Core.Definition.getDefinition('Publier la semaine')}}</b-button>
                                        <b-dropdown variant="success" size="sm" right no-caret>
                                            <template slot="button-content">
                                                <i class="fa fa-angle-down"></i>
                                            </template>
                                            <b-dropdown-item @click="$refs.modalConfirmDraftWeek.open = true" href="#">{{Core.Definition.getDefinition('Enregistrer comme brouillons')}}</b-dropdown-item>
                                            <b-dropdown-item @click="$refs.modalWeekSelector.open = true" href="#">{{Core.Definition.getDefinition('Appliquer sur les semaines ...')}}</b-dropdown-item>
                                            <b-dropdown-item @click="$refs.modalConfirmTrashWeek.open = true" href="#">{{Core.Definition.getDefinition('Supprimer la semaine')}}</b-dropdown-item>
                                        </b-dropdown>
                                    </b-button-group>

                                    <slot name="afterActions">
                                    </slot>

                                </b-col>
                            </b-row>

                            <div v-if="dataShowFilter">
                                <b-row class="mt-4">
                                    <b-col md="12" lg="12">
                                        <strong class="text-muted">{{Core.Definition.getDefinition('Filtres')}}</strong>
                                        <hr/>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col v-if="Core.Setting.getSetting('event.seasonIsEnabled')=='true'" lg="3" md="6" sm="12">
                                        <InputMultiSelect v-model="dataFilter.type" :label="Core.Definition.getDefinition('Saison')" :options="dataSelectOptions.seasonId"></InputMultiSelect>
                                    </b-col>
                                    <b-col v-if="Core.Setting.getSetting('event.leagueIsEnabled')=='true'" lg="3" md="6" sm="12">
                                        <InputMultiSelect v-model="dataFilter.type" :label="Core.Definition.getDefinition('Ligue')" :options="dataSelectOptions.leagueId"></InputMultiSelect>
                                    </b-col>
                                    <b-col lg="3" md="6" sm="12">
                                        <InputMultiSelect v-model="dataFilter.type" :label="Core.Definition.getDefinition('Type d\'événement')" :options="dataSelectOptions.type"></InputMultiSelect>
                                    </b-col>
                                    <b-col lg="3" md="6" sm="12">
                                        <InputMultiSelect v-model="dataFilter.eventId" :label="Core.Definition.getDefinition('Événement')" :options="dataSelectOptions.eventId"></InputMultiSelect>
                                    </b-col>
                                    <b-col lg="3" md="6" sm="12">
                                        <InputMultiSelect v-model="dataFilter.status" :label="Core.Definition.getDefinition('État')" :options="dataSelectOptions.status"></InputMultiSelect>
                                    </b-col>
                                    <b-col lg="3" md="6" sm="12">
                                        <InputMultiSelect v-model="dataFilter.userId" :label="Core.Definition.getDefinition('Responsable')" :options="dataSelectOptions.userId"></InputMultiSelect>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-4">
                                    <b-col class="text-right">
                                        <b-button-group class="btn-group-sm">
                                            <b-button @click="reload" class="btn btn-light mr-2">{{Core.Definition.getDefinition('Réinitialiser')}}</b-button>
                                            <b-button @click="onSearchClick" class="btn btn-info">{{Core.Definition.getDefinition('Rechercher')}}</b-button>
                                        </b-button-group>
                                    </b-col>
                                </b-row>
                            </div>

                            <hr class="mb-5" />
                            <b-row>
                                <b-col class="text-center">
                                    <WeekPagination v-model="dataWeekPagination"></WeekPagination>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <EventList
                                            ref="eventList"
                                            :displayEditMode="true"
                                            :events="dataEventDates"
                                            @onEventClick="onEventClick">
                                    </EventList>
                                </b-col>
                            </b-row>
                        </b-card>
                    </slot>
                </Request>
            </slot>
        </Request>
        
        <ModalConfirm
                @onConfirm="publishWeek"
                :caption="Core.Definition.getDefinition('Publier la semaine')"
                :message="Core.Definition.getDefinition('Voulez-vous publier tous les événements de la semaine? Tous les événements de la semaine seront publiés et visibles par les utilisateurs.')"
                ref="modalConfirmPublishWeek">
        </ModalConfirm>

        <ModalConfirm
                @onConfirm="draftWeek"
                :caption="Core.Definition.getDefinition('Semaine en mode brouillons')"
                :message="Core.Definition.getDefinition('Voulez-vous mettre en mode brouillons tous les événements de la semaine? Tous les événements de la semaine seront en mode brouillons et non visibles par les utilisateurs.')"
                ref="modalConfirmDraftWeek">
        </ModalConfirm>

        <ModalConfirm
                @onConfirm="trashWeek"
                okVariant="danger"
                :messageInAlert="true"
                alertVariant="danger"
                :caption="Core.Definition.getDefinition('Supprimer la semaine')"
                :message="Core.Definition.getDefinition('Voulez-vous supprimer tous les événements de la semaine? Tous les événements de la semaine seront supprimés cette action est irréversible.')"
                ref="modalConfirmTrashWeek">
        </ModalConfirm>

        <ModalConfirm
                @onConfirm="replaceWeek"
                okVariant="danger"
                :messageInAlert="true"
                alertVariant="danger"
                :caption="Core.Definition.getDefinition('Remplacer la semaine')"
                :message="Core.Definition.getDefinition('Voulez-vous remplacer tous les événements de la semaine? Tous les événements de la semaine seront supprimés cette action est irréversible.')"
                ref="modalConfirmReplaceWeek">
        </ModalConfirm>

       <ModalConfirm
                        @onConfirm="createTemplate"
                        :closeOnConfirm="false"
                        :caption="Core.Definition.getDefinition('Nouveau modèle')"
                        ref="modalConfirmCreateTemplate">
                    <slot slot="body">
                        <Request
                                ref="requestCreateTemplate"
                                root="/event-week-template"
                                method="POST"
                                :onRequestSuccess="createTemplateSuccess"
                                :onRequestError="requestError">
                            <slot slot="body">
                                <InputText
                                        :label="Core.Definition.getDefinition('Titre')"
                                        v-model="dataTemplate.title"></InputText>
                                <InputLongText
                                        :label="Core.Definition.getDefinition('Description')"
                                        v-model="dataTemplate.description"></InputLongText>
                            </slot>
                        </Request>
                    </slot>
        </ModalConfirm>

        <ModalConfirm
                @onConfirm="saveTemplate"
                :closeOnConfirm="false"
                :caption="Core.Definition.getDefinition('Enregistrer comme modèle')"
                ref="modalConfirmSaveTemplate">
            <slot slot="body">
                <Request
                        ref="requestSaveTemplate"
                        root="/event-week-template"
                        method="POST"
                        :onRequestSuccess="saveTemplateSuccess"
                        :onRequestError="requestError">
                    <slot slot="body">
                        <InputText
                                :label="Core.Definition.getDefinition('Titre')"
                                v-model="dataTemplate.title"></InputText>
                        <InputLongText
                                :label="Core.Definition.getDefinition('Description')"
                                v-model="dataTemplate.description"></InputLongText>
                    </slot>
                </Request>
            </slot>
        </ModalConfirm>

        <ModalWeekSelector
                @onConfirm="publishWeeks"
                ref="modalWeekSelector">
        </ModalWeekSelector>

        <ModalInstanceSelector
                ref="modalEventTemplateSelector"
                :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun modèle à afficher'),
                                borderVariant: 'white',
                                noBody: true
                }"
                :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                }
                ]"
                root="/event-week-template/list"
                v-model="dataTemplates"
                :multiple="false">
        </ModalInstanceSelector>

        <ModalEventDate
                ref="modalEventDate"
                :ignoreRouteParamId="true"
                :seasonId="seasonId"
                :options=" {
                format: {
                   value: 'YYYY-MM-DD',
                   label: 'dddd, DD MMMM YYYY',
                   startOf: 'isoWeek'
                 },
                 root: {
                    save: '/event-calendar-panel',
                    get: '/event-calendar-panel',
                    trash: '/event-calendar-panel'
                 },
                 defaultValue: {
                    status: 'hidden'
                 },
                 displayActions: true
            }"
                @onTrashSuccess="reload"
                @onBackClick="modalEventDateOnBackClick"
                @onSaveSuccess="modalEventDateOnSaveSuccess">
        </ModalEventDate>

        <ModalEventDateAddBooking
                ref="modalEventDateAddBooking"
                @onBackClick="modalEventDateOnBackClick"
                :options="{
                     root: {
                        save: '/event-calendar-panel',
                        get: '/event-calendar-panel',
                        trash: '/event-calendar-panel'
                     }
                }">
        </ModalEventDateAddBooking>

        <ModalEventDateOverview
                ref="modalEventDateOverview"
                @onEditClick="onEventDateEditClick"
                @onAddBookingClick="onEventDateAddBookingClick"
                @onBookingsClick="onEventDateBookingsClick">
        </ModalEventDateOverview>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import ModalConfirm from '../../components/ModalConfirm'
    import Modal from '../../components/Modal'
    import ModalInstanceSelector from '../../components/ModalInstanceSelector'
    import ModalEventDate from '../../components/ModalEventDate'
    import ModalWeekSelector from '../../components/ModalWeekSelector'
    import ModalEventDateOverview from '../../components/ModalEventDateOverview'
    import ModalEventDateAddBooking from '../../components/ModalEventDateAddBooking'
    import Request from '../../components/Request'
    import EventList from '../../components/EventList'
    import WeekPagination from '../../components/WeekPagination'
    import InputText from '../../components/InputText'
    import InputLongText from '../../components/InputLongText'
    import InputMultiSelect from '../../components/InputMultiSelect'
    import InputSelect from '../../components/InputSelect'
    import InputCheckbox from '../../components/InputCheckbox'
    import DynamicForm from '../../components/DynamicForm'
    export default {
        name: 'EventCalendarList',
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        date: {
                            firstDayOfWeek: 'monday',
                        }
                    }
                }
            },
            _showFilter: {
                type: Boolean,
                default: true
            },
            seasonId: {
                type: String | Number,
                default: ''
            }
        },
        components: {
            InputLongText,
            ModalConfirm,
            Request,
            EventList,
            WeekPagination,
            ModalEventDate,
            ModalWeekSelector,
            ModalInstanceSelector,
            InputText,
            InputMultiSelect,
            InputCheckbox,
            InputSelect,
            Modal,
            DynamicForm,
            ModalEventDateAddBooking,
            ModalEventDateOverview
        },
        watch: {
            dataWeekPagination: {
                handler(val) {
                    this.request(val.start, val.end)
                },
                deep: true
            },
            dataTemplates: {
                handler(val) {
                    this.$refs.modalEventTemplateSelector.open = false
                    this.$refs.modalConfirmReplaceWeek.open = true
                },
                deep: true
            }
        },
        mounted() {
            this.dataShowFilter = this._showFilter
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataShowFilter: true,
                dataWeekPagination: {
                    start: Core.Date.getToday('YYYY-MM-DD'),
                    end: ''
                },
                dataEvent: {
                    modal: {
                        show: true
                    },
                },
                dataEventCalendarStatus: {
                    caption: '',
                    badgeVariant: '',
                    cardClass: ''
                },
                dataTemplate: {
                    title: '',
                    description: ''
                },
                dataTemplates: [],
                dataResponsables: [],
                dataSelectOptions: [],
                dataFilter: {
                    type: [],
                    userId: [],
                    eventId: [],
                    status: [],
                    displayAvailability: false
                },
                dataEventDates: []
            }
        },
        computed: {
            showFilter: {
                set(val) {
                    this.dataShowFilter = val
                },
                get() {
                    return this.dataShowFilter
                }
            }
        },
        methods: {
            renderEventTitle(event) {
                return event.title
            },
            renderEventContent(event) {
                let status = Mantle.EventDate.getStatusLabelWithIcon(event.status)
                let bookings = Mantle.Event.readableBookingCount(event.eventDateBookingCount, event.max)
                let contents = []
                contents.push(status)
                contents.push('<i class="fa fa-users"></i> ' + bookings)
                return contents.join('<br/>')
            },
            renderEventAlt(event) {
                if(event.status === 'draft') {
                    return event.title + ' (' + Core.Definition.getDefinition('Brouillon') + ')'
                }
                if(event.status === 'hidden') {
                    return event.title + ' (' + Core.Definition.getDefinition('Caché') + ')'
                }
                if(event.status === 'cancelled') {
                    return event.title + '<i class="ml-1">(' + Core.Definition.getDefinition('Annulé') + ')</i>'
                }
                return event.title
            },
            switchStatus(status) {
                switch(status){
                    case Mantle.EventCalendar.statusReady:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-light'
                        this.dataEventCalendarStatus.badgeVariant = 'light'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('')
                        break
                    case Mantle.EventCalendar.statusError:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-danger'
                        this.dataEventCalendarStatus.badgeVariant = 'danger'
                        break
                    case Mantle.EventCalendar.statusLoading:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-info'
                        this.dataEventCalendarStatus.badgeVariant = 'info'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Chargement de la semaine ...')
                        break
                    case Mantle.EventCalendar.statusPublishing:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-info'
                        this.dataEventCalendarStatus.badgeVariant = 'info'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Publication en cours ...')
                        break
                    case Mantle.EventCalendar.statusSaving:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-info'
                        this.dataEventCalendarStatus.badgeVariant = 'info'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Enregistrement en cours ...')
                        break
                    case Mantle.EventCalendar.statusRemoving:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-warning'
                        this.dataEventCalendarStatus.badgeVariant = 'warning'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Supression en cours ...')
                        break
                    default:
                        break
                }
            },
            request(start, end) {
                this.switchStatus(Mantle.EventCalendar.statusLoading)
                this.$refs.requestDates.clearArgs()
                this.$refs.requestDates.addArg('groupBy', 'date')
                this.$refs.requestDates.addArg('start', start)
                this.$refs.requestDates.addArg('end', end)
                this.$refs.requestDates.addArg('seasonId', this.seasonId)
                this.$refs.requestDates.addArg('type', Core.Value.decode(this.dataFilter.type, Core.Value.typeMultiSelect))
                this.$refs.requestDates.addArg('userId', Core.Value.decode(this.dataFilter.userId, Core.Value.typeMultiSelect))
                this.$refs.requestDates.addArg('eventId', Core.Value.decode(this.dataFilter.eventId, Core.Value.typeMultiSelect))
                this.$refs.requestDates.addArg('status', Core.Value.decode(this.dataFilter.status, Core.Value.typeMultiSelect))
                this.$refs.requestDates.request()
            },
            reset() {
                let startOf = 'isoWeek'
                if (this.options.date.firstDayOfWeek === 'sunday') {
                    startOf = 'week'
                }
                this.dataWeekPagination.start = Vue.moment().startOf(startOf).format('YYYY-MM-DD')
                this.dataWeekPagination.end = Vue.moment().startOf(startOf).format('YYYY-MM-DD')
            },
            requestError(data) {
            },
            onAddEvent() {
                this.$refs.modalEventDate.id = ''
                this.$refs.modalEventDate.date = this.dataWeekPagination.start
                this.$refs.modalEventDate.open = true
            },
            onTimeClick(date, time, dayOfWeek) {
                if (Core.Session.AuthUser.can('event_calendar_management_post')) {
                    this.$refs.modalEventDate.id = ''
                    this.$refs.modalEventDate.timeStart = time
                    this.$refs.modalEventDate.timeEnd = Vue.moment(Vue.moment().format('YYYY-MM-DD ' + time)).add('hour', 1).format('HH:mm')
                    this.$refs.modalEventDate.date = date
                    this.$refs.modalEventDate.open = true
                }
            },
            onEventClick(event, date) {
                date = Vue.moment(date).format('YYYY-MM-DD')
                this.$refs.modalEventDateOverview.event = event
                this.$refs.modalEventDateOverview.date = date
                this.$refs.modalEventDateOverview.open = true
            },
            onEventDateEditClick(event, date) {
                this.$refs.modalEventDateOverview.open = false
                this.$refs.modalEventDate.event = event
                this.$refs.modalEventDate.date = date
                this.$refs.modalEventDate.id = event.id
                this.$refs.modalEventDate.days = Vue.moment(date).daysInMonth()
                this.$refs.modalEventDate.open = true
            },
            onEventDateAddBookingClick(event, date) {
                this.$refs.modalEventDateOverview.open = false
                this.$refs.modalEventDateAddBooking.event = event
                this.$refs.modalEventDateAddBooking.date = date
                this.$refs.modalEventDateAddBooking.open = true
            },
            onEventDateBookingsClick(event, date) {
                this.$refs.modalEventDateOverview.open = false
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/evenement/reservations/{0}/{1}'), date, event.id))
            },
            onSearchClick() {
                this.request(this.dataWeekPagination.start, this.dataWeekPagination.end)
            },
            modalEventDateOnSaveSuccess(data) {
                if (data.eventDates !== undefined) {
                    for(let eventDate in data.eventDates) {
                        eventDate = data.eventDates[eventDate]
                        this.$refs.eventList.updateEvent(eventDate)
                    }
                }
            },
            modalEventDateOnBackClick() {
                this.$refs.modalEventDate.open = false
                this.$refs.modalEventDateAddBooking.open = false
                this.$refs.modalEventDateOverview.open = true
            },
            reload() {
                this.dataFilter.type = []
                this.dataFilter.userId = null
                this.dataFilter.eventId = []
                this.dataFilter.status = []
                this.dataFilter.displayAvailability = false
                this.request(this.dataWeekPagination.start, this.dataWeekPagination.end)
            },
            updateEvents(data) {

                if(this.$refs.eventList !== undefined) {
                    this.$refs.eventList.clearEvents()
                    this.$refs.eventList.dataEvents = data.eventDates
                }

                if (data.selectOptions !== undefined) {
                    this.dataSelectOptions = data.selectOptions
                }

                this.switchStatus(Mantle.EventCalendar.statusReady)
            },
            trashWeek() {
                this.$refs.calendarWeek.clearEvents()
                this.switchStatus(Mantle.EventCalendar.statusRemoving)
                this.$refs.requestPublish.clearArgs()
                this.$refs.requestPublish.addArg('start', this.dataWeekPagination.start)
                this.$refs.requestPublish.addArg('end', this.dataWeekPagination.end)
                this.$refs.requestPublish.addArg('status', 'archive')
                this.$refs.requestPublish.request()
            },
            draftWeek() {
                this.switchStatus(Mantle.EventCalendar.statusSaving)
                this.$refs.requestPublish.clearArgs()
                this.$refs.requestPublish.addArg('start', this.dataWeekPagination.start)
                this.$refs.requestPublish.addArg('end', this.dataWeekPagination.end)
                this.$refs.requestPublish.addArg('status', 'draft')
                this.$refs.requestPublish.request()
            },
            publishWeek() {
                this.switchStatus(Mantle.EventCalendar.statusPublishing)
                this.$refs.requestPublish.clearArgs()
                this.$refs.requestPublish.addArg('start', this.dataWeekPagination.start)
                this.$refs.requestPublish.addArg('end', this.dataWeekPagination.end)
                this.$refs.requestPublish.addArg('status', 'publish')
                this.$refs.requestPublish.request()
            },
            publishWeeks(weeks) {
                this.switchStatus(Mantle.EventCalendar.statusPublishing)
                this.$refs.requestPublish.clearArgs()
                this.$refs.requestPublish.addArg('start', this.dataWeekPagination.start)
                this.$refs.requestPublish.addArg('end', this.dataWeekPagination.end)
                this.$refs.requestPublish.addArg('weeks', window.Core.Value.decode(weeks, 'JSON')),
                this.$refs.requestPublish.addArg('status', 'publish')
                this.$refs.requestPublish.request()
            },
            createTemplate() {
                this.$refs.modalConfirmCreateTemplate.disableConfirm = true
                this.$refs.requestCreateTemplate.clearArgs()
                this.$refs.requestCreateTemplate.addArg('title', this.dataTemplate.title)
                this.$refs.requestCreateTemplate.addArg('description', this.dataTemplate.description)
                this.$refs.requestCreateTemplate.request()
            },
            saveTemplate() {
                this.$refs.modalConfirmSaveTemplate.disableConfirm = true
                this.$refs.requestSaveTemplate.clearArgs()
                this.$refs.requestSaveTemplate.addArg('title', this.dataTemplate.title)
                this.$refs.requestSaveTemplate.addArg('description', this.dataTemplate.description)
                this.$refs.requestSaveTemplate.addArg('start', this.dataWeekPagination.start)
                this.$refs.requestSaveTemplate.addArg('end', this.dataWeekPagination.end)
                this.$refs.requestSaveTemplate.request()
            },
            saveTemplateSuccess(data) {
                this.$refs.modalConfirmSaveTemplate.disableConfirm = false
                if (data.id !== undefined) {
                    this.$router.push('/evenement/calendrier/modeles')
                }
            },
            createTemplateSuccess(data) {
                this.$refs.modalConfirmCreateTemplate.disableConfirm = false
                if (data.error === undefined && data.id !== undefined) {
                    this.$router.push(Core.Definition.getDefinition(Core.Text.format('/evenement/calendrier/modeles/{0}',data.id)))
                }
            },
            replaceWeek() {
                if (this.dataTemplates[0].instance!==undefined) {
                    if (this.dataTemplates[0].instance.id !== undefined) {
                        this.switchStatus(Mantle.EventCalendar.statusLoading)
                        this.$refs.requestDates.clearArgs()
                        this.$refs.calendarWeek.clearEvents()
                        this.$refs.requestDates.addArg('eventWeekTemplateId', this.dataTemplates[0].instance.id)
                        this.$refs.requestDates.addArg('start', this.dataWeekPagination.start)
                        this.$refs.requestDates.addArg('end', this.dataWeekPagination.end)
                        this.$refs.requestDates.request()
                    }
                }
            }
        }
    }
</script>
